import { useGetHolidaysSpecial } from 'queries';
import { useTranslation } from 'react-i18next';

import {
  convertResponseWithStringDate,
  useHolidaysSpecialColumns
} from './utils';

import { SPECIALS_HOLIDAYS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditForm from './components/CreateEditForm';

const HolidaySpecial = () => {
  const { t } = useTranslation('common');

  const holidaysSpecialColumns = useHolidaysSpecialColumns();
  const { data, isFetching } = useGetHolidaysSpecial();

  const { mutate: deleteItem } = useDeleteById(SPECIALS_HOLIDAYS, [
    'holidays-special'
  ]);

  return (
    <TableCRUDLayout
      FormComponent={CreateEditForm}
      rows={convertResponseWithStringDate(data)}
      loading={isFetching}
      columns={holidaysSpecialColumns}
      sortModel={[
        {
          field: 'date',
          sort: 'asc'
        }
      ]}
      confirmationTitle={t(
        'adminPortal.tables.deleteHolidaysSpecialDialog.title'
      )}
      confirmationBody={t(
        'adminPortal.tables.deleteHolidaysSpecialDialog.body'
      )}
      getRowId={(row) => row.holidaySpecialId}
      onDeleteClick={deleteItem}
    />
  );
};

export default HolidaySpecial;
